export const perPageDefault = 10;

export const rowsPerPageOptionsDefault = [perPageDefault, perPageDefault * 5, perPageDefault * 10];
